import {
    FaGithub,
    FaFacebookSquare,
    FaInstagramSquare,
    FaYoutubeSquare,
    FaHamburger
  } from "react-icons/fa";
  import { BsTwitterX } from "react-icons/bs";
  import { FaVolumeUp } from "react-icons/fa";
  import { FaLinkedin } from "react-icons/fa";

  
  export const LinkedInIcon = () => <FaLinkedin/>;
  export const GitHubIcon =  () =>  <FaGithub/>;
  export const FacebookIcon =  () => <FaFacebookSquare/>;
  export const InstagramIcon =  () => <FaInstagramSquare/> ;
  export const YoutubeIcon =  () => <FaYoutubeSquare/>;
  export const VolumeIcon =  () => <FaVolumeUp/>;
  export const MenuIcon =  () => <FaHamburger/>;
  export const XIcon =  () => <BsTwitterX/>;
  export { BiLink as LinkIcon } from "react-icons/bi";



export { FiChevronDown as ChevronDownIcon, FiChevronUp as ChevronUpIcon } from "react-icons/fi";
export { HiArrowSmRight as ArrowRightIcon, HiMail as MailIcon } from "react-icons/hi";
export { IoMoon as MoonIcon, IoSunny as SunIcon } from "react-icons/io5";
